module.exports = __webpack_public_path__ + "static/media/34.b1c13cd0.jpg";